(function (socialShare) {
  return (window.simpleJSSocialShare = socialShare());
})(function () {
  function extend(output) {
    output = output || {};
    Array.from(arguments, (argumentItem) => {
      if (!argumentItem) {
        return;
      }
      for (let key in argumentItem) {
        if (argumentItem.hasOwnProperty(key)) {
          output[key] = argumentItem[key];
        }
      }
    });
    return output;
  }

  // get data attribute
  function getData(el, defaultOptions) {
    let data = {};
    for (let key in defaultOptions) {
      if (defaultOptions.hasOwnProperty(key)) {
        let value = el.getAttribute('data-' + key);
        if (value !== null && typeof value != 'undefined') {
          data[key] = value;
        }
      }
    }
    return data;
  }

  //open social popup window
  function popup(url, options) {
    return window.open(
      url,
      '',
      'toolbar=0,status=0,scrollbars=1,width=' +
        options.popup_width +
        ',height=' +
        options.popup_height
    );
  }

  //get URL for every option
  function getURL(options) {
    if (options.url === '') {
      options.url = location.href;
    }
    let url = options.url;
    let utm = '';
    if (options.utm_source !== '') {
      utm += '&utm_source=' + options.utm_source;
    }
    if (options.utm_medium !== '') {
      utm += '&utm_medium=' + options.utm_medium;
    }
    if (options.utm_campaign !== '') {
      utm += '&utm_campaign=' + options.utm_campaign;
    }
    if (utm !== '') {
      url = url + '?' + utm;
    }
    return url;
  }

  let social = {
    // default handler
    unknown: function (options) {
      return encodeURIComponent(getURL(options));
    },

    // Facebook
    facebook: function (options) {
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(getURL(options))}`;
    },

    // whatsapp
    whatsapp: function (options) {
      return `https://api.whatsapp.com/send?text=${encodeURIComponent(options.title)}%20${encodeURIComponent(getURL(options))}`;
    },

    // linkedin
    linkedin: function (options) {
      return `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(getURL(options))}&title=${encodeURIComponent(options.title)}&summary=${encodeURIComponent(options.text)}`;
    },

    // X (Twitter rebrand)
    x: function (options) {
      let url = getURL(options);
    return `https://twitter.com/share?text=${encodeURIComponent(options.title)}&url=${encodeURIComponent(url)}&counturl=${encodeURIComponent(url)}`;
    },

    // E-mail
    email: function (options) {
      return `mailto:?subject=${encodeURIComponent(options.title)}&body=${encodeURIComponent(getURL(options))}${encodeURIComponent('\n' + options.text)}`;
    },
  };

  function init() {
    let defaultOptions = {
      type: 'email',
      url: '',
      title: document.title,
      image: '',
      text: '',
      utm_source: '',
      utm_medium: '',
      utm_campaign: '',
      popup_width: 626,
      popup_height: 436,
    };

    function api() {}

    function go(element, options) {
      let withoutPopup = ['unknown', 'email'];
      let tryLocation = true;
      let link;

      options = extend(
        defaultOptions,
        getData(element, defaultOptions),
        options
      );

      if (typeof social[options.type] == 'undefined') {
        options.type = 'unknown';
      }

      link = social[options.type](options);

      if (withoutPopup.indexOf(options.type) === -1) {
        tryLocation = popup(link, options) === null;
      }

      if (tryLocation) {
        if (element.tagName === 'A' && element.tagName === 'a') {
          element.setAttribute('href', link);
          return true;
        } else {
          location.href = link;
          return false;
        }
      } else {
        return false;
      }
    }

    api.go = go;
    api.options = defaultOptions;
    return api;
  }

  return init();
});
